/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RouteResponseRoute } from './RouteResponseRoute';
import {
    RouteResponseRouteFromJSON,
    RouteResponseRouteFromJSONTyped,
    RouteResponseRouteToJSON,
} from './RouteResponseRoute';

/**
 * 
 * @export
 * @interface RouteResponse
 */
export interface RouteResponse {
    /**
     * Timestamp of last received position
     * @type {string}
     * @memberof RouteResponse
     */
    bsTs?: string;
    /**
     * Total distance of the route in meters
     * @type {number}
     * @memberof RouteResponse
     */
    distance?: number;
    /**
     * Estimated arrival time at destination
     * @type {string}
     * @memberof RouteResponse
     */
    eta?: string;
    /**
     * 
     * @type {RouteResponseRoute}
     * @memberof RouteResponse
     */
    route?: RouteResponseRoute;
    /**
     * Speed Over Ground of last received position
     * @type {number}
     * @memberof RouteResponse
     */
    sog?: number;
    /**
     * Status of the route calculation (e.g., "ok")
     * @type {string}
     * @memberof RouteResponse
     */
    status?: string;
}

/**
 * Check if a given object implements the RouteResponse interface.
 */
export function instanceOfRouteResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RouteResponseFromJSON(json: any): RouteResponse {
    return RouteResponseFromJSONTyped(json, false);
}

export function RouteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RouteResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bsTs': !exists(json, 'bs_ts') ? undefined : json['bs_ts'],
        'distance': !exists(json, 'distance') ? undefined : json['distance'],
        'eta': !exists(json, 'eta') ? undefined : json['eta'],
        'route': !exists(json, 'route') ? undefined : RouteResponseRouteFromJSON(json['route']),
        'sog': !exists(json, 'sog') ? undefined : json['sog'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function RouteResponseToJSON(value?: RouteResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bs_ts': value.bsTs,
        'distance': value.distance,
        'eta': value.eta,
        'route': RouteResponseRouteToJSON(value.route),
        'sog': value.sog,
        'status': value.status,
    };
}

